
<!-- 使用范例
    <SystemGuide
        placement="right"
        :guideType="1"
        :title="title"
        :content="desc"
        :buttons="[]"
        :isGuideFinished="false">
        <RightSuspension slot="system-guide-slot"></RightSuspension>
    </SystemGuide>
    <SystemGuide
        @close-event="clickHandler"
        placement="left"
        :title="title"
        :guideType="2"
        :content="desc"
        :buttons="[
            {
                text: '跳转按钮',
                callback: 'goto',
            },
        ]"
        :isGuideFinished="isFirstRead">
        <slot name="global-system-guide-slot" slot="system-guide-slot"></slot>
    </SystemGuide>
    <SystemGuide
        @close-event="clickHandler"
        placement="left"
        :title=""
        :guideType="2"
        :content="desc"
        :buttons="[]"
        :isGuideFinished="isFirstRead">
        <slot name="global-system-guide-slot" slot="system-guide-slot"></slot>
    </SystemGuide>

系统引导，样式类型: guideType
1: title + ontent
2: title + content + buttons
3: content
-->
<template>
    <el-popover
        :placement="placement"
        title=""
        width="auto"
        :trigger="trigger"
        v-model="visible"
        data-class="popover-custom-class"
        popper-class="popover-custom-class">
        <section :class="`system-guide-container system-guide-container-${guideType}`">
            <div :class="`close-icon-container close-icon-container-${guideType}`">
                <span class="close-icon-box system-guide-close-icon"
                      @click="closeHandler">
                    <i class="el-icon el-icon-close"></i>
                </span>
            </div>
            <div :class="`title-box title-box-${guideType}`">
                <span v-if="title" class="title">
                    {{title || ''}}
                </span>
            </div>
            <div :class="`content-box content-box-${guideType}`">
                <p>{{content || ''}}</p>
            </div>
            <div class="buttons-box" v-if="buttons.length > 0">
                <el-button
                    v-for="({text, callback}, index) in buttons"
                    :key="index"
                    type="default"
                    size="mini"
                    @click="callbackHandler(callback)">
                    {{text || ''}}
                </el-button>
            </div>
        </section>
        <slot name="system-guide-slot" slot="reference"></slot>
    </el-popover>
</template>

<script>
export default {
    name: 'DapSystemGuide',
    props: {
        isGuideFinished: {
            type: Boolean,
            default: false,
            required: true,
        },
        // 1: title + ontent
        // 2: title + content + buttons
        // 3: content
        guideType: {
            type: Number,
            default: 1,
            required: true,
        },
        placement: {
            type: String,
            // top/top-start/top-end & bottom/bottom-start/bottom-end
            // left/left-start/left-end & right/right-start/right-end
            default: 'right',
            required: true,
        },
        title: {
            type: String,
            default: null,
            // default: '',
        },
        content: {
            type: String,
            default: null,
            required: true,
        },
        // {text, callback}
        buttons: {
            type: Array,
            default: [],
        },
        method: {
            type: Function,
        },
    },
    data () {
        return {
            visible: false,
            trigger: 'manual',
        };
    },
    watch: {
        isGuideFinished: function (val) {
            this.visible = val;
        },
    },
    methods: {
        closeHandler () {
            this.$emit('close-event');
        },
        callbackHandler (callback) {
            this.$emit(callback);
            // window.open(window.location.href);
        },
    },
    mounted () {
        this.visible = this.isGuideFinished || false;
    },
};
</script>

<style lang="scss">
.popover-custom-class {
    background: linear-gradient(316deg, #2C6FDD 0%, #5998FF 100%) !important;;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2) !important;
    border: 0 !important;
    margin: 0;
    padding: 20px !important;
    user-select: none;
    $l: left;
    $r: right;
    $t: top;
    $b: bottom;
    $positions: $l, $r, $t, $b;
    $triangle: #3477e3;
    @each $key in $positions {
        &[x-placement^="#{$key}"] .popper__arrow{
            // right: -18px !important;
            border-#{$key}-color: $triangle !important;
        }
        &[x-placement^="#{$key}"] .popper__arrow::after {
            border-#{$key}-color: $triangle !important;
            // border-width: 9px !important;
        }
    }
    $min: 1;
    $max: 3;
    @for $i from $min through $max {
        .system-guide-container-#{$i} {
            color: #fff;
        }
    }
    .system-guide-container {
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: center;
        .close-icon-container {
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-end;
            justify-content: center;
            position: relative;
            width: 100%;
            cursor: pointer;
            .close-icon-box {
                position: absolute;
                top: -15px;
                right: -5px;
                width: 8px;
                height: 8px;
            }
            .close-icon-box::after {
                clear: both;
                display: block;
                width: 0;
                height: 0;
            }
        }
        .title-box {
            .title {
                width: 112px;
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 20px;
            }
        }
        .content-box {
            min-width: 199px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 17px;
            margin-top: 10px;
        }
        .content-box-1 {
            width: 199px;
        }
        .buttons-box {
            display: flex;
            // flex-flow: row-reverse nowrap;
            flex-flow: row nowrap;
            align-items: center;
            // justify-content: space-between;
            justify-content: flex-end;
            margin-top: 10px;
            width: 100%;
            .el-button {
                box-sizing: border-box;
                // width: auto;
                height: 28px;
                padding: 5px 10px;
                background: #FFFFFF;
                border-radius: 4px;
                span {
                    height: 17px;
                    font-size: 12px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #4285F4;
                    line-height: 17px;
                }
            }
        }
    }
    .system-guide-container-1 {
        width: 208px;
    }
    .system-guide-container-2 {
        width: calc(332px - 40px - 20px);
    }
    .system-guide-container-2 {
        width: calc(334px - 40px - 20px);
    }
}
</style>
